import { Box, Breadcrumbs, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

export interface BreadcrumbLink {
  label: string;
  href?: string;
}

const BreadcrumbItem: React.FC<{ link: BreadcrumbLink }> = ({ link }) => {
  const hasLink = link.href && link.href !== '#';
  return (
    <Button
      component={hasLink ? Link : 'span'}
      to={hasLink ? link.href : undefined}
      size="small"
      disabled={!hasLink}
      sx={{
        py: 0.5,
        px: 0.75,
        height: 'auto',
        '&.Mui-disabled': { color: 'secondary.main' },
        ':hover,:focus': { textDecoration: 'underline', textUnderlinePosition: 'under' },
      }}
    >
      {link.label}
    </Button>
  );
};

const homeBreadcrumbLink: BreadcrumbLink = { label: 'Home', href: '/' };
export const Breadcrumb: React.FC = () => {
  const { hide, links } = useAppSelector((state) => state.breadcrumb);
  if (hide || links.length === 0) return null;

  return (
    <Box className="container-fluid" sx={{ py: 1, bgcolor: 'warning.light', whiteSpace: 'nowrap', overflowX: 'auto' }}>
      <Breadcrumbs
        separator="/"
        aria-label="breadcrumb"
        sx={{ ml: -0.75, '.MuiBreadcrumbs-ol': { flexWrap: 'nowrap' } }}
      >
        <BreadcrumbItem link={homeBreadcrumbLink} />
        {links.map((link, index) => (
          <BreadcrumbItem key={link.href ?? index} link={link} />
        ))}
      </Breadcrumbs>
    </Box>
  );
};
